import { CircularProgress } from "@mui/material";
import { ErrorOutline, FiberManualRecord } from "@mui/icons-material";

import { INDICATOR_COLORS } from "./constants";

import type { SaveState } from "./types";

interface TabIndicatorProps {
  saveState: SaveState;
  hasContent: boolean;
}

/**
 * Priority-based status indicator for a carrier tab.
 *
 * Priority order: error > saving > unsaved > saved (with content).
 * Returns null when there is nothing to indicate.
 */
const TabIndicator = ({
  saveState,
  hasContent,
}: TabIndicatorProps): React.JSX.Element | null => {
  switch (saveState) {
    case "error":
      return (
        <ErrorOutline
          data-testid="tab-indicator-error"
          sx={{ fontSize: 16, color: INDICATOR_COLORS.error, ml: 0.5 }}
        />
      );
    case "saving":
      return (
        <CircularProgress
          data-testid="tab-indicator-saving"
          size={12}
          sx={{ ml: 0.5 }}
        />
      );
    case "unsaved":
      return (
        <FiberManualRecord
          data-testid="tab-indicator-unsaved"
          sx={{ fontSize: 10, color: INDICATOR_COLORS.unsaved, ml: 0.5 }}
        />
      );
    case "saved":
      if (!hasContent) return null;
      return (
        <FiberManualRecord
          data-testid="tab-indicator-saved"
          sx={{ fontSize: 10, color: INDICATOR_COLORS.saved, ml: 0.5 }}
        />
      );
  }
};

export default TabIndicator;
